export default {"src":"/_next/static/media/pin_dinner.a68112ed.svg","height":29,"width":21,"blurWidth":0,"blurHeight":0};